<template>
  <div
    v-if="!$store.state.desktop"
    id="footerBar"
    class="footerBar"
    :class="{
      'is-login': login,
      shadow: $route.name == 'Download',
      fixed: fixed,
    }"
  >
    <div class="footerContent">
      <!-- <div
        v-if="$store.state.webConfig.phone_customer_service_number"
        class="flex between bottomLine"
      >
        <div class="contactUs">
          <p class="title">联系我们</p>
          <p class="normal">我们设立了儿童个人信息保护专职部门</p>
          <p class="tel">{{ $store.state.webConfig.phone_customer_service_number }}</p>
          <p class="normal lessWeight">周一至周日(10:00-19:30)</p>
        </div>
        <div class="aboutUs">
          <p class="title">关于我们</p>
          <img class="logo" :src="$store.state.webConfig.web_footer_logo" />
          <p class="normal">{{ $store.state.webConfig.copyright }}</p>
        </div>
        <div class="appDownlod">
          <p class="title">APP下载</p>
          <div class="qrCode"><img class="img" :src="appDownlodQrCode" /></div>
        </div>
      </div> -->
      <div class="registration flex atignCenter justifyCenter">
        <span>
          APP备案号：
          <span class="hover">{{ $store.state.webConfig.app_record_no }}</span>
        </span>
        <span class="line" />
        <span>
          查询链接:
          <a class="link" :href="$store.state.webConfig.record_no_link" target="_blank">
            {{ $store.state.webConfig.record_no_link }}
          </a>
        </span>
      </div>
      <div class="registration flex atignCenter justifyCenter">
        <span class="hover">{{ $store.state.webConfig.record_no }}</span>
        <span class="line" />
        <img class="gongan" src="@/assets/images/gongan.png" />
        <span>Copyright © {{ $store.state.webConfig.copyright }} All rights reserved</span>
      </div>
    </div>
    <!-- <p class="copyright">
      <span>{{ $store.state.webConfig.copyright }}</span>
      <a :href="$store.state.webConfig.record_no_link" target="_blank">
        {{ $store.state.webConfig.record_no }}
      </a>
      <a
        :href="$store.state.webConfig.public_security_record_no_link"
        target="_blank"
        style="margin-left: 18px"
      >
        <img src="@/assets/images/gongan.png" style="vertical-align: middle; margin-right: 5px" />
        <span>{{ $store.state.webConfig.public_security_record_no }}</span>
      </a>
    </p> -->
    <!-- <p class="copyright custom">
      {{ $store.state.webConfig.contact }}
    </p> -->
    <!-- <p
      class="copybottom"
      v-if="$store.state.commonSetting.saas_enable == 1 && $store.state.webConfig.show_brand == 1"
    >
      <span>
        由
        <a href="https://www.baijiayun.com" target="_blank">
          <img class="sm-logo" :src="smlogo" />
          百家云
        </a>
        |
        <a href="https://www.baijiayunxiao.com/index" target="_blank">
          <img class="sm-logo" :src="yxlogo" />
          百家云校
        </a>
        提供技术支持
      </span>
      <br />
      <span>SaaS网校，就用百家云校！</span>
    </p> -->
  </div>
</template>

<script>
import smlogo from '../assets/images/sm-logo.png';
import yxlogo from '../assets/images/yx-logo.png';
export default {
  name: 'Footer',
  props: {
    login: {
      default: false,
    },
    teacher: {
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    appDownlodQrCode() {
      return this.isCzScenes
        ? 'https://mstt.oss-cn-qingdao.aliyuncs.com/uploads/file/cC3jp0Orzljgm3Ig.png'
        : 'https://mstt.oss-cn-qingdao.aliyuncs.com/uploads/file/RXcdrrM9ftOn962Y.png';
    },
  },
  data() {
    return {
      isCzScenes: location.hostname.includes('czmstt'),
      smlogo,
      yxlogo,
    };
  },
};
</script>
<style lang="scss" scoped>
.footerBar {
  padding: 48px 0;
  background: rgba(38, 33, 47, 1);
  box-sizing: border-box;
  z-index: 999;
  position: relative;
  &.shadow {
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
  }
  &.fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .footerContent {
    width: 1200px;
    margin: 0 auto;
    .flex {
      display: flex;
    }
    .between {
      justify-content: space-between;
    }
    .atignCenter {
      align-items: center;
    }
    .justifyCenter {
      justify-content: center;
    }
    .mt32 {
      margin-top: 32px;
    }
    .bottomLine {
      padding-bottom: 48px;
      border-bottom: 1px solid #54535c;
      margin-bottom: 32px;
    }
    .contactUs,
    .aboutUs,
    .appDownlod {
      color: #fff;
      .title {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        margin: 0 0 20px 0;
      }
      .normal {
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        margin: 0;
        color: #8c8b97;
      }
      .lessWeight {
        font-weight: 400;
      }
      .tel {
        font-size: 32px;
        font-weight: 600;
        line-height: 30px;
        margin: 8px 0;
      }
    }
    .aboutUs {
      .logo {
        width: 140px;
        display: block;
        margin-bottom: 8px;
      }
    }
    .appDownlod {
      text-align: center;
      .qrCode {
        padding: 10px;
        border-radius: 8px;
        background: #fff;
        .img {
          width: 80px;
          height: 80px;
          display: block;
        }
      }
    }
    .registration {
      padding-top: 16px;
      color: #706e79;
      text-align: center;
      .hover:hover {
        color: #fff;
      }
      .line {
        width: 1px;
        height: 12px;
        background-color: #706e79;
        margin: 0 12px;
        display: inline-block;
      }
      .link {
        color: #706e79;
      }
      .link:hover {
        color: #00c0f3;
        text-decoration: underline;
      }
      .gongan {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .registration:first-child {
      padding-top: 0;
    }
  }
}

.footerBar .link {
  text-align: center;
}

.footerBar .link li,
.footerBar .link a {
  margin-right: 54px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: white;
  line-height: 20px;
  &:last-child {
    margin-right: 0;
  }
}

.footerBar .link li.phone {
  border: none;
}

.footerBar .link li span,
.footerBar .link li a {
  display: block;
}

.footerBar .copyright {
  margin: 13px auto 0 auto;
  text-align: center;
  font-size: 15px;
  color: rgba($color: white, $alpha: 0.5);
  line-height: 20px;
  a {
    color: rgba($color: white, $alpha: 0.5);
    vertical-align: middle;
  }
  span {
    margin-right: 18px;
    vertical-align: middle;
  }
}

.custom {
  margin-top: 12px !important;
}
.copybottom {
  display: block;
  margin: 27px auto 0 auto;
  text-align: center;
  font-size: 14px;
  color: white;
  line-height: 16px;
  opacity: 0.5;
  a {
    color: white;
  }
  span {
    display: inline-block;
    color: white;
    margin-bottom: 5px;
  }
  .sm-logo {
    position: relative;
    top: 1px;
    height: 12px;
    width: 20px;
    margin: 0 5px;
    margin-top: 5px;
  }
}
</style>
